import { Link } from "gatsby";
import isEven from "@functions/isEven";
import * as React from "react";
import cx from "classnames";
import * as classess from "@styles/button.module.css";

/**
 *
 * @param {{text: string, navigateTo: string, counter: int}} props
 */

const Button = (props) => {
  let counter = props.counter;
  const title = props.text.charAt(0).toUpperCase() + props.text.slice(1);
  return (
    <button
      className={cx(
        isEven(counter) ? classess.bg_first : classess.bg_second,
        classess.button
      )}
    >
      <Link to={`#${props.navigateTo}`}>
        <span
          className={cx(
            isEven(counter) ? classess.text_first : classess.text_second
          )}
        >
          {title}
        </span>
      </Link>
    </button>
  );
};

export default Button;
